import React from 'react';
import { Alert, StyleSheet, Text, TouchableOpacity, View } from './rn';
import { fontSize, radius, spacing } from '../theme';
import { useTheme } from '../theme/ThemeContext';
import { useTranslation } from '../i18n/I18nContext';
import { openLocationMap, validMapPoint } from '../navigation/locationMaps';

export type LocationCard = {
  latitude: number;
  longitude: number;
  district?: string | null;
  city?: string | null;
};

/** İçerik sunucuda doğrulanıp normalleştiriliyor; burada yalnız çözülüyor. */
export function parseLocationCard(content: string): LocationCard | null {
  try {
    const d = JSON.parse(content);
    const lat = d?.latitude;
    const lng = d?.longitude;
    if (!validMapPoint(lat, lng)) return null;
    return {
      latitude: lat, longitude: lng,
      district: typeof d?.district === 'string' ? d.district : null,
      city: typeof d?.city === 'string' ? d.city : null,
    };
  } catch {
    return null;
  }
}

/** Yer adı varsa o, yoksa koordinat. Aynı ad iki kez yazılmaz. */
export function locationLabel(card: LocationCard): string {
  const parcalar = [card.district, card.city]
    .filter((v, i, hepsi) => v && hepsi.indexOf(v) === i) as string[];
  if (parcalar.length > 0) return parcalar.join(' · ');
  return `${card.latitude.toFixed(5)}, ${card.longitude.toFixed(5)}`;
}

type Props = {
  card: LocationCard;
  mine: boolean;
  onLongPress: () => void;
};

/**
 * Sohbetteki konum satırı (9.3.3.1 · D-576).
 *
 * Harita burada ÇİZİLMİYOR. Listede on harita karesi hem yavaş hem pahalıdır;
 * dokununca paylaşılan nokta sistem haritasında açılır (9.3.3.5).
 * Kart yerin adını taşıyor, ad çözülemediyse koordinatı.
 *
 * Bu madde tek seferlik gönderim: süre, durdurma ve izleyen kavramı yok.
 * Onlar canlı paylaşıma ait (9.3.3.2).
 */
export default function MessageLocation({ card, mine, onLongPress }: Props) {
  const colors = useTheme();
  const { t } = useTranslation();
  const renk = mine ? colors.white : colors.black;
  const openMap = async () => {
    try {
      await openLocationMap(card.latitude, card.longitude);
    } catch {
      Alert.alert(t('message.locationTitle'), t('message.locationMapError'));
    }
  };
  return (
    <TouchableOpacity
      testID="message-location"
      activeOpacity={0.9}
      accessibilityRole="button"
      accessibilityHint={t('message.liveLocationOpenInMaps')}
      onPress={openMap}
      onLongPress={onLongPress}>
      <View style={styles.card}>
        <Text style={[styles.title, { color: renk }]}>{t('message.locationTitle')}</Text>
        <Text testID="message-location-label" style={[styles.label, { color: renk }]}>
          {locationLabel(card)}
        </Text>
        <Text style={[styles.title, { color: renk }]}>{t('message.liveLocationOpenInMaps')}</Text>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: { minWidth: 160, gap: spacing.xs, borderRadius: radius.card },
  title: { fontSize: fontSize.sm, opacity: 0.7 },
  label: { fontSize: fontSize.md, fontWeight: '600' },
});
